function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/js/utils';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import AnalyticService from '@/apps/analytic-services/services/analytic_service.js';
import tasks from '@/js/tasks';
export default {
  name: 'AreaPage',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  data: function data() {
    return {
      mlops_configs: [],
      mode: '',
      record: {
        'cloud_storage': {},
        'service_accounts': {}
      },
      record_original: {
        'cloud_storage': {},
        'service_accounts': {}
      },
      select_profile_areas: [],
      areas_to_filters: [],
      dialogFlag: false,
      modalId: 'dp_area',
      collapse_filter: false,
      menu: false,
      menu2: false,
      dates: [],
      filters: {
        fechas: []
      },
      alert: false,
      countDown: {
        timer: '3',
        show: false
      },
      filter_enabled: false,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      config_reference: null
    };
  },
  computed: {
    /* ...mapState('data-platform', ['select_profile_areas']),*/headers: function headers() {
      return [{
        value: 'id',
        text: 'ID',
        sortable: true,
        class: 'text-left'
      }, {
        value: 'project_id',
        text: 'Proyecto',
        sortable: true,
        class: 'text-left',
        align: 'left'
      }, {
        value: 'region',
        text: 'Región',
        sortable: true,
        class: 'text-center',
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'text-center',
        align: 'center'
      }];
    },
    texts: function texts() {
      return {
        name: this.traductor('tablas.name'),
        active: this.traductor('frases.activo'),
        updated_by: this.traductor('frases.updated_by'),
        update_date: this.traductor('frases.update_date'),
        create: this.traductor('frases.create'),
        rango: this.traductor('filtros.rango'),
        creador: this.traductor('tablas.creator')
      };
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    },
    modalName: function modalName() {
      return 'Permiso';
    },
    rows: function rows() {
      return this.select_profile_areas.length;
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName;
      var aux = 'crud.' + mode;
      var modename = this.traductor(aux);
      return "".concat(modename, " ").concat(modalName);
    },
    readonly: function readonly() {
      return this.mode === 'view';
    }
  },
  created: function created() {
    this.get_configs();
  },
  methods: {
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.$refs['dialogConfirmation'].onOpen();
    },
    get_configs: function get_configs() {
      var _this = this;
      var params2 = {
        domain: window.userInfo.domain
      };
      AnalyticService.get_configs(params2).then(function (response) {
        _this.mlops_configs = response.data;
        console.log(response);
      });
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this2 = this;
      if (!event) {
        this.$refs['dialogConfirmation'].onClose();
        return;
      }
      console.log(this.record);
      var params = {
        domain: window.userInfo.domain,
        id: this.record.id
      };
      AnalyticService.delete_config(params).then(function (datos) {
        console.log(datos);
        _this2.$refs['dialogConfirmation'].onClose();
        tasks.toast.success('Eliminado correctamente');
        _this2.get_configs();
      }, function (err) {
        _this2.$refs['dialogConfirmation'].onClose();
        tasks.toast.error(err.message ? err.message : 'An error occurred, please try again!');
      });
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (this.mode == 'create') {
        console.log('para backend', this.record);
        var params = {
          domain: window.userInfo.domain,
          config: this.record
        };
        AnalyticService.create_config(params).then(function (response) {
          console.log(response);
          if (response.data) {
            tasks.toast.success('Creado correctamente.');
            _this3.$refs.dialog.onClose();
            _this3.get_configs();
          } else {
            tasks.toast.error('No se pudo crear. Intente nuevamente.');
          }
        });
        // eslint-disable-next-line eqeqeq
      } else if (this.mode == 'edit') {
        var _params = {
          domain: window.userInfo.domain,
          config: this.record
        };
        AnalyticService.update_config(_params).then(function (response) {
          console.log(response);
          if (response.data) {
            tasks.toast.success('Editado correctamente.');
            _this3.$refs.dialog.onClose();
            _this3.get_configs();
          } else {
            tasks.toast.error('No se pudo editar. Intente nuevamente.');
          }
        });
      }
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.recordSelected = data.index;
        this.record = utils.cloneJSON(data.item);
        this.record_original = utils.cloneJSON(data.item);
      } else {
        console.log('en vacio');
        this.record = {
          'cloud_storage': {},
          'service_accounts': {}
        };
      }
      this.mode = mode;
      this.$refs.dialog.onOpen();
    },
    onSearch: function onSearch() {
      var _this4 = this;
      this.select_profile_areas = Object.assign([], this.areas_to_filters);
      if (this.filters.nombre) {
        // eslint-disable-next-line eqeqeq
        this.select_profile_areas = this.select_profile_areas.filter(function (x) {
          return x.area_description.toUpperCase().indexOf(_this4.filters.nombre.toUpperCase()) != -1;
        });
      }
      if (this.filters.creador) {
        // eslint-disable-next-line eqeqeq
        this.select_profile_areas = this.select_profile_areas.filter(function (x) {
          return x.creator_user.toUpperCase().indexOf(_this4.filters.creador.toUpperCase()) != -1;
        });
      }
      if (this.filters.fechas) {
        if (_typeof(this.filters.fechas) === 'object') {
          if (this.filters.fechas.length > 1) {
            this.select_profile_areas = this.select_profile_areas.filter(function (x) {
              return x.load_date.substring(0, 10) >= _this4.filters.fechas[0] && x.load_date.substring(0, 10) <= _this4.filters.fechas[1];
            });
          }
        }
      }
    },
    onLimpiar: function onLimpiar() {
      this.select_profile_areas = Object.assign([], this.areas_to_filters);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
    }
  }
};